<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-my-projects">
  <div class="org-admin-my-projects--layout">
    <app-org-admin-sidebar class="org-admin-my-projects--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-my-projects--content">
      <app-page-header></app-page-header>

      <div *ngIf="accessLevel === 'loading'" class="org-admin-my-projects--access org-admin-my-projects--access-loading">
        <p>Checking access…</p>
      </div>

      <ng-container *ngIf="accessLevel === 'full'">
        <app-my-project></app-my-project>
      </ng-container>
    </div>
  </div>
</div>

<app-modal
  [visible]="showAccessModal"
  header="Upgrade Your Role"
  width="480px"
  [showFooter]="false"
  (visibleChange)="onAccessModalClose($event)"
>
  <div class="org-admin-my-projects--modal-content">
    <div class="org-admin-my-projects--modal-leaf">
      <img src="/assets-leaf.png" alt="" class="org-admin-my-projects--modal-leaf-img" />
    </div>
    <div class="org-admin-my-projects--modal-body">
      <p *ngIf="accessLevel === 'none'">You need the Compute role to access My Projects. Request the Compute role or contact your administrator.</p>
      <p *ngIf="accessLevel === 'pending'">Your Compute role request is pending <span class="org-admin-my-projects--modal-highlight">approval</span>. You will get access to My Projects once it is approved.</p>
      <div class="org-admin-my-projects--modal-actions">
        <button
          type="button"
          class="org-admin-my-projects--role-upgrade-btn"
          [disabled]="accessLevel === 'pending'"
          (click)="onRoleUpgradeClick()"
        >
          {{ accessLevel === 'pending' ? 'Request Sent' : 'Role Upgrade' }}
        </button>
      </div>
    </div>
  </div>
</app-modal>
